<template>
  <b-container class="metric-info">
    <b-row class="pb-2">
      <b-col>
        <h4>{{ labels.subtitle }}</h4>
        <p class="mt-3 text-gray04">{{ labels.reliabilityRate.questions }}</p>
        <b-row>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="gray02" class="subtitle">
                {{ labels.status.notAnswered }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="info" class="subtitle">
                {{ labels.status.skip }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="red10" class="subtitle">
                {{ labels.status.veryLow }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="red09" class="subtitle">
                {{ labels.status.low }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="warning" class="subtitle">
                {{ labels.status.medium }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="green" class="subtitle">
                {{ labels.status.high }}
              </b-progress-bar>
            </b-progress>
          </b-col>
          <b-col>
            <b-progress :max="100" show-value class="mt-3">
              <b-progress-bar :value="100" variant="success" class="subtitle">
                {{ labels.status.veryHigh }}
              </b-progress-bar>
            </b-progress>
          </b-col>
        </b-row>
        <p class="mt-4 text-gray04">
          {{ labels.reliabilityRate.title1 }}
          {{ labels.reliabilityRate.title2 }}
        </p>
        <b-row>
          <b-col>
            <b-progress
              class="mt-3"
              :max="100"
              show-value
              :title="
                `${labels.reliabilityRate.veryLow}: 0% ~ 20% ${labels.reliabilityRate.responders}`
              "
            >
              <b-progress-bar :value="100" variant="red10">
                {{ labels.reliabilityRate.veryLow }}
              </b-progress-bar>
            </b-progress>
            <p class="text-center">
              {{ `0% ~ 20% ${labels.reliabilityRate.responders}` }}
            </p>
          </b-col>
          <b-col>
            <b-progress
              class="mt-3"
              :max="100"
              show-value
              :title="
                `${labels.reliabilityRate.low}: 20% ~ 40% ${labels.reliabilityRate.responders}`
              "
            >
              <b-progress-bar :value="100" variant="red09">
                {{ labels.reliabilityRate.low }}
              </b-progress-bar>
            </b-progress>
            <p class="text-center">
              {{ `20% ~ 40% ${labels.reliabilityRate.responders}` }}
            </p>
          </b-col>
          <b-col>
            <b-progress
              class="mt-3"
              :max="100"
              show-value
              :title="
                `${labels.reliabilityRate.medium}: 40% ~ 60% ${labels.reliabilityRate.responders}`
              "
            >
              <b-progress-bar :value="100" variant="warning">
                {{ labels.reliabilityRate.medium }}
              </b-progress-bar>
            </b-progress>
            <p class="text-center">
              {{ `40% ~ 60% ${labels.reliabilityRate.responders}` }}
            </p>
          </b-col>
          <b-col>
            <b-progress
              class="mt-3"
              :max="100"
              show-value
              :title="
                `${labels.reliabilityRate.high}: 60% ~ 80% ${labels.reliabilityRate.responders}`
              "
            >
              <b-progress-bar :value="100" variant="green">
                {{ labels.reliabilityRate.high }}
              </b-progress-bar>
            </b-progress>
            <p class="text-center">
              {{ `60% ~ 80% ${labels.reliabilityRate.responders}` }}
            </p>
          </b-col>
          <b-col>
            <b-progress
              class="mt-3"
              :max="100"
              show-value
              :title="
                `${labels.reliabilityRate.veryHigh}: 80% ~ 100% ${labels.reliabilityRate.responders}`
              "
            >
              <b-progress-bar :value="100" variant="success">
                {{ labels.reliabilityRate.veryHigh }}
              </b-progress-bar>
            </b-progress>
            <p class="text-center">
              {{ `80% ~ 100% ${labels.reliabilityRate.responders}` }}
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return {
        ...this.resources.component.customSurveys.reports.questions,
        reliabilityRate: this.resources.page.reports.engagement.metric
          .reliabilityRate,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

.metric-info {
  margin: 0.5rem 0.5rem 0rem 0rem;
  width: 100%;

  h4 {
    border-radius: 30px;
    color: map-get($theme-colors, 'gray04');
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 0px;

    @media (max-width: 1350px) {
      font-size: 13px;
    }

    @media (max-width: 320px) {
      font-size: 14px;
    }
  }

  p {
    color: map-get($theme-colors, 'gray02');
    font-size: 12px;
    text-decoration: none;
    margin: 0;
  }

  .subtitle {
    padding-left: 20px;
    padding-right: 20px;
  }
}
</style>
